import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';
import LoginForm from './components/LoginForm';
import IntakeForm from './pages/intakeForm';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'
import SubmitViewIntakeForm from './pages/submitViewIntakeForm';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
